<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="19"
    height="20"
    viewBox="0 0 19 20"
  >
    <g
      id="页面-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g>
        <g>
          <path
            id="more1"
            d="M0,9.58377889579773C0,10.13606889579773,0.447715,10.58377889579773,1,10.58377889579773L7.38607,10.58377889579773C7.93835,10.58377889579773,8.38607,10.13606889579773,8.38607,9.58377889579773L8.38607,3.0235888957977295C8.38607,2.4713038957977296,7.93835,2.0235888957977295,7.38607,2.0235888957977295L1,2.0235888957977295C0.447715,2.0235888957977295,0,2.4713038957977296,0,3.0235888957977295L0,9.58377889579773Z"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
        <g>
          <path
            id="more2"
            d="M0,18.999991216125487C0,19.552281216125486,0.447715,19.999991216125487,1,19.999991216125487L7.38607,19.999991216125487C7.93835,19.999991216125487,8.38607,19.552281216125486,8.38607,18.999991216125487L8.38607,12.439801216125488C8.38607,11.887516216125489,7.93835,11.439801216125488,7.38607,11.439801216125488L1,11.439801216125488C0.447715,11.439801216125488,0,11.887516216125489,0,12.439801216125488L0,18.999991216125487Z"
            fill="transparent"
            fill-rule="nonzero"
          />
        </g>
        <g>
          <path
            id="more3"
            d="M9.224672317504883,18.999991216125487C9.224672317504883,19.552281216125486,9.672387317504883,19.999991216125487,10.224672317504883,19.999991216125487L16.610742317504883,19.999991216125487C17.163022317504883,19.999991216125487,17.610742317504883,19.552281216125486,17.610742317504883,18.999991216125487L17.610742317504883,12.439801216125488C17.610742317504883,11.887516216125489,17.163022317504883,11.439801216125488,16.610742317504883,11.439801216125488L10.224672317504883,11.439801216125488C9.672387317504883,11.439801216125488,9.224672317504883,11.887516216125489,9.224672317504883,12.439801216125488L9.224672317504883,18.999991216125487Z"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
        <g
          transform="matrix(0.6998041272163391,-0.7143347859382629,0.6998041272163391,0.7143347859382629,-1.3127882974114868,7.503963857271458)"
        >
          <path
            id="more4"
            d="M8.326282501220703,12.073892843933105C8.326282501220703,12.626172843933105,8.773997501220704,13.073892843933105,9.326282501220703,13.073892843933105L14.952502501220703,13.073892843933105C15.504782501220703,13.073892843933105,15.952502501220703,12.626172843933105,15.952502501220703,12.073892843933105L15.952502501220703,6.4476728439331055C15.952502501220703,5.895387843933105,15.504782501220703,5.4476728439331055,14.952502501220703,5.4476728439331055L9.326282501220703,5.4476728439331055C8.773997501220704,5.4476728439331055,8.326282501220703,5.895387843933105,8.326282501220703,6.4476728439331055L8.326282501220703,12.073892843933105Z"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "FollowSvg",
  props: {
    color: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$el.querySelector('#more1').setAttribute("fill", this.color);
      this.$el.querySelector('#more2').setAttribute("fill", this.color);
      this.$el.querySelector('#more3').setAttribute("fill", this.color);
      this.$el.querySelector('#more4').setAttribute("fill", this.color);
    },
  },
};
</script>
